import React from 'react'

import { Box, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

export const DEFAULT_OPTIONS = {
  employee_status: 'employee_status',
  location: 'location',
  team: 'team',
}

export interface State {
  advanced: boolean
  fieldSelected: string
}

export interface Action {
  type: string
  field?: string
}

export interface TooltipProps {
  label: string
  enabled: boolean
}

export const constants = {
  RESET_FILTER_COUNT: 0,
  DEFAULT_FILTER_COUNT: 1,
  CHANGE_SELECTED_FIELD: 'change_selected_field',
  RESET_FIELDS: 'reset_fields',
  USE_ADVANCED_FILTER: 'used_advanced_filter',
}

export const CustomTooltip = ({
  label,
  enabled,
  children,
}: React.PropsWithChildren<TooltipProps>) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt attachment="top center" open={open && enabled} toggle={toggle} label={label}>
      {/* This Box prevents the tooltip from miscalculating the position when CounterBadge.count == 0 */}
      <Box>{children}</Box>
    </Tooltip.Alt>
  )
}
